import * as Sentry from '@sentry/react';
import { FieldTextCompact, Pushbutton } from '@stratumn/atomic';
import to from 'await-to-js';
import { UploadPhoto } from 'components/ui';
import { ROUTE_MY_PROFILE } from 'constant/routes';
import compose from 'lodash.flowright';
import { updateUser } from 'mutations';
import PropType from 'prop-types';
import { useState } from 'react';
import injectSheet from 'react-jss';
import { withRouter } from 'react-router-dom';
import { SpanType, withSpanAsync } from 'tracing';
import { withGqlClient, withRestClient, withUser } from 'wrappers';

import styles from './editProfile.style';

export function EditProfile(props) {
  const { classes, environment, client, history, user } = props;

  const [submitted, setSubmit] = useState(false);
  const [firstName, setFirstName] = useState(user.firstName || '');
  const [lastName, setLastName] = useState(user.lastName || '');
  const [phone, setPhone] = useState(user.phone || '');
  const [avatar, setAvatar] = useState(user.avatar || '');

  const isValid = () => {
    const regex = /^[0-9+()\-. ]{0,20}$/;
    return !submitted && !!firstName && !!lastName && phone.match(regex);
  };

  const onSubmit = () => {
    withSpanAsync('updateUserInSignup', SpanType.processing, async () => {
      setSubmit(true);

      let avatarUrl;

      if (avatar instanceof File) {
        const { digest } = await client.media.uploadFile(avatar, {
          disableEncryption: true
        });
        avatarUrl = await client.media.buildDownloadURL(digest);
      }

      const [err] = await to(
        updateUser(
          environment,
          user.rowId,
          firstName,
          lastName,
          phone,
          avatarUrl
        )
      );

      if (err) {
        Sentry.captureException(err);
        setSubmit(false);
      } else {
        history.push(ROUTE_MY_PROFILE);
      }
    });
  };

  return (
    <div className={classes.formWrapper}>
      <div className={classes.avatarWrapper}>
        <UploadPhoto
          avatar={JSON.stringify(avatar)}
          data-testid="upload-photo"
          getNewAvatar={setAvatar}
          overlay
          size={56}
          user
        />
      </div>

      <div className={classes.fieldWrapper}>
        <FieldTextCompact
          data-testid="input-firstname"
          label="First name"
          onValueChange={e => setFirstName(e.target.value)}
          value={firstName}
        />
      </div>
      <div className={classes.fieldWrapper}>
        <FieldTextCompact
          data-testid="input-lastname"
          label="Last name"
          onValueChange={e => setLastName(e.target.value)}
          value={lastName}
        />
      </div>
      <div className={classes.fieldWrapper}>
        <FieldTextCompact
          data-testid="input-phone"
          label="Phone"
          onValueChange={e => setPhone(e.target.value)}
          value={phone}
        />
      </div>
      <div className={classes.formBtnWrapper}>
        <div className={classes.formBtnLeft}>
          <Pushbutton
            data-testid="cancel-button"
            onClick={() => history.push(ROUTE_MY_PROFILE)}
          >
            cancel
          </Pushbutton>
        </div>
        <Pushbutton
          data-testid="save-button"
          disabled={!isValid() || submitted}
          onClick={() => onSubmit()}
          primary
        >
          save
        </Pushbutton>
      </div>
    </div>
  );
}

EditProfile.propTypes = {
  classes: PropType.object.isRequired,
  environment: PropType.object.isRequired,
  client: PropType.object.isRequired,
  history: PropType.object.isRequired,
  user: PropType.object.isRequired
};

export default compose(
  withUser,
  withRouter,
  withGqlClient,
  withRestClient,
  injectSheet(styles)
)(EditProfile);
